// extracted by mini-css-extract-plugin
export var Container = "style-module--Container--2gaVY";